import React from "react";
import { StaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

const InlineRelated = (props) => (
  <StaticQuery
    query={graphql`
      query {
        allMdx(sort: { frontmatter: { date: DESC } }) {
          edges {
            node {
              id
              frontmatter {
                title
                excerpt
                date
                path
                category
                image {
                  childImageSharp {
                    gatsbyImageData(width: 600, layout: CONSTRAINED)
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => {
      const blogID = props.path;
      const posts = data.allMdx.edges;
      const post = posts.find((edge) => edge.node.frontmatter.path === blogID)
        .node.frontmatter;
      const link = `https://howtovietnamese.com/${post.path}`;
      const image = getImage(post.image);
      return (
        <a target="_blank" className="inline_related_card " href={link}>
          <div className="inline_related_title">
            <span>Related</span>
          </div>
          {image ? (
            <GatsbyImage
              className="inline_related_image"
              image={image}
              alt={post.title}
            />
          ) : null}
          <a target="_blank" href={link} className="inline_related_text">
            {post.title}
          </a>
        </a>
      );
    }}
  />
);

export default InlineRelated;
